<!-- [MATCH-READ-C-POP] 보낸 신청서 보기(기업) -->
<!-- [MATCH-READ-P-POP] 보낸 신청서 보기(개인) -->

<template>
  <div v-if="matchPeople">
    <BasicModal
      :isShowModal="isModal"
      @close-modal="$store.commit('directMatching/setHideModalPopup')"
      title="받은 신청서 보기"
      disabledFooter
    >
      <div class="popupViewProfile">
        <CorpInfoCard
          v-if="matchPeople.roleName == $role.CORP"
          :data="matchPeople"
        />
        <UserInfoCard
          v-else-if="matchPeople.roleName == $role.USER"
          :data="matchPeople"
        />

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <div style="margin-left: 2rem;">
          <MatchingProcess />
        </div>

        <section>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <div style="margin-bottom: 50px;">
                <h3 class="matchingHeadLine">신청서</h3>
                <LabelInput label="신청 대상 기업" :value="matchPeople.name" />
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="selectedDirectMatching.requestReason"
                    :errors="errors"
                    readonly
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <LabelInput label="신청자 이름" :value="selfAccount.name" />
                <LabelInput label="이메일 주소" :value="selfAccount.email" />
                <LabelInput label="전화번호" :value="selfAccount.phoneNumber" />
              </div>

              <div class="modal-action">
                <template v-if="isReceiver">
                  <MainButton
                    btnText="승인서 작성"
                    size="large"
                    @click="
                      $store.commit(
                        'directMatching/setOpenModalPopup',
                        'matchAcceptPopup'
                      )
                    "
                  />
                  <MainButton
                    btnText="거절서 작성"
                    size="large"
                    color="red2"
                    @click="
                      $store.commit(
                        'directMatching/setOpenModalPopup',
                        'matchDenyPopup'
                      )
                    "
                  />
                </template>
                <template v-else>
                  <MainButton
                    btnText="확인"
                    @click="$store.commit('directMatching/setHideModalPopup')"
                  />
                </template>
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MatchingProcess from "@/components/items/MatchingProcess.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";
import matchingPopupMixins from "@/mixins/matching-popup-mixins";
import LabelInput from "@/components/formControl/LabelInput.vue";

export default {
  name: "DirectMatchReadPopup",
  components: {
    BasicModal,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    MainButton,
    MatchingProcess,
    CorpInfoCard,
    UserInfoCard,
    LabelInput,
  },
  props: {
    isModal: Boolean,
  },
  mixins: [matchingPopupMixins],
  data() {
    return {
      form: {},
    };
  },

  methods: {
    onClickSubmitForm() {},
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>
